import {
  CircularProgressProps,
  ProgressProps,
  ProgressState,
} from './ProgressIndicator.types';

export const getSegmentsFromSteps = (steps: ProgressProps[]) =>
  steps.reduce((segments: CircularProgressProps[], step, i) => {
    const segment = segments[segments.length - 1];
    const color = getProgressStateColor(step.state);

    if (!segment || segment.color !== color) {
      segments.push({
        total: steps.length,
        from: i,
        to: i + 1,
        color,
      });
    } else {
      segment.to++;
    }

    return segments;
  }, []);

export const getRadians = ({
  step,
  total,
  paddingInRadians,
}: {
  step: number;
  total: number;
  paddingInRadians: number;
}) => (step / total) * 2 * Math.PI - Math.PI / 2 + paddingInRadians;

export const getCoordinates = (radians: number) => ({
  x: 5 + Math.cos(radians) * 5,
  y: 5 + Math.sin(radians) * 5,
});

export const getProgressStateColor = (state: ProgressState) => {
  switch (state) {
    case 'active':
      return '--data-color-background-active';
    case 'touched':
    case 'completed':
      return '--data-color-background-success-light';
    case 'untouched':
      return '--data-color-background-placeholder';
  }
};

export const SegmentCap = ({
  radians,
  width,
}: {
  radians: number;
  width: number;
}) => {
  const { x, y } = getCoordinates(radians);
  return (
    <path
      d={`M ${x} ${y} L ${x - ((x - 5) / 5) * width} ${
        y - ((y - 5) / 5) * width
      }`}
      stroke={`var(--global-color-background-white)`}
      strokeWidth="0.2"
    />
  );
};
